import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import constants from "../../assets/constants";
import * as PatientSessionActions from "../../state/redux/patientSession";
import { deepCopyObject, helperGetIsoDate } from "../../utils/helpers";
import PatientSymptomsDialog from "../dialogs/patientSymptomsDialog";
import BotpressChatListItem from "../ui/botpressChatListItem";
import SymptomTrackingToDoListItem from "../ui/symptomTrackingToDoListItem";
import Widget from "../ui/widget";
import WidgetList from "../ui/widgetList";
import WidgetSkeleton from "../ui/widgetSkeleton";
import WidgetTitle from "../ui/widgetTitle";

const HyperbaricPartnerToDos = props => {
  const {
    proxyPatientODM,
    //hot garbage below
    userODM,
  } = props;

  //this class uses proxypatient state to determine the ToDos

  const [symptomDaysNeeded, setSymptomDaysNeeded] = useState(null);

  useEffect(() => {
    let theReturn = [];

    if (
      proxyPatientODM != null &&
      proxyPatientODM.omniData != null &&
      proxyPatientODM.omniData.patientData.symptomODMs.length > 0
    ) {
      //checking for the last 3 days

      for (let daysPast = 0; daysPast < 3; ++daysPast) {
        let targetDateString = helperGetIsoDate(daysPast).substring(0, 10);
        for (
          let index = 0;
          index < proxyPatientODM.omniData.patientData.symptomODMs.length;
          ++index
        ) {
          let found = proxyPatientODM.omniData.patientData.symptomODMs[index].timeSeries.find(
            obj => obj.date === targetDateString,
          );
          if (found == null) {
            //didn't find it, need to add
            theReturn.push(daysPast);
            break;
          }
        }
      }
    }
    setSymptomDaysNeeded(theReturn);
  }, [proxyPatientODM]);

  const [titleText, setTitleText] = useState("");
  const [title, setTitle] = useState("Loading...");
  useEffect(() => {
    if (symptomDaysNeeded != null) {
      setTitle("Health Coach");
      let length = symptomDaysNeeded.length;
      setTitleText(`${length} ${length === 1 ? "Suggestions" : "Suggestions"}`);
    }
  }, [symptomDaysNeeded]);

  const [recordSymptomsDay, setRecordSymptomsDay] = useState(null);

  // //all below is HOT garbage--------------------------------------------------------------------------
  // const [changedToDo, setChangedToDo] = useState(undefined);

  // const populateInvitationSharingVars = org => {
  //   let invShareVars = constants.defaultInvitationSharingVars;

  //   if (org === constants.organizationTypeEnums.hyperbaric) {
  //     invShareVars = constants.hyperbaricInvitationSharingVars;
  //   }
  //   return invShareVars;
  // };

  return (
    <Widget>
      <WidgetTitle title={title} text={titleText} loading={userODM == null}></WidgetTitle>
      {symptomDaysNeeded == null && <WidgetSkeleton />}
      {symptomDaysNeeded != null && (
        <WidgetList>
          {symptomDaysNeeded.map(day => {
            return (
              <SymptomTrackingToDoListItem
                daysInThePast={day}
                onClickHandler={day => setRecordSymptomsDay(day)}
              />
            );
          })}
          <BotpressChatListItem
            onClickHandler={() => {
              props.history.push(constants.appPaths.appPathPartnerChat);
            }}
          />
        </WidgetList>
      )}

      {recordSymptomsDay != null && (
        <PatientSymptomsDialog
          open={recordSymptomsDay != null}
          daysInThePast={recordSymptomsDay}
          symptomODMs={proxyPatientODM.omniData.patientData.symptomODMs}
          onAccept={updatedSymptoms => {
            let newPatientODM = deepCopyObject(proxyPatientODM); //might not need?
            newPatientODM.omniData.patientData.symptomODMs = updatedSymptoms;
            props.updatePatientRequest(newPatientODM);
            setRecordSymptomsDay(null);
          }}
          onClose={() => {
            setRecordSymptomsDay(null);
          }}
        />
      )}
    </Widget>
  );
};

const mapStateToProps = state => ({
  userODM: state.userSession.userODM,

  //legit below
  proxyPatientODM: state.userSession.proxyPatientODM,
});

const mapDispatchToProps = {
  updatePatientRequest: PatientSessionActions.updatePatientRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HyperbaricPartnerToDos));
